import React, { useContext, useState, useRef } from 'react';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button } from '@thd-olt-component-react/button';
import { I_DONT_KNOW } from '../../../constants';
import CarPickerContext from '../../../context/CarPickerContext';
import { savePersistedState } from '../../car-picker-helpers';
import { carPickerAnalyticsEvent } from '../../../analytics';
import styles from './car-picker-buttons.module.scss';

const classes = classNames.bind(styles);

export const CarPickerButtons = () => {
  const { channel } = useContext(ExperienceContext);
  const {
    fitmentOptions,
    selectedOption,
    onCarSelectionChange,
    pipFitmentRequest,
    pageType,
    triggerFitmentItemsCallback,
    optionTypes,
    dispatch
  } = useContext(CarPickerContext);

  const isMobile = channel === 'mobile';
  const isPlp = pageType !== 'pip';

  let staticDropDownOptions = Object.keys(fitmentOptions);
  const remainingOptions = staticDropDownOptions?.filter((key) => {
    return selectedOption[key]?.displayValue?.includes('Pick Your');
  });
  const [selectionMade, setSelectionMade] = useState(false);
  const initialCallbackOnValidation = useRef(true);

  const handleSelectionUpdate = () => {
    if (!selectionMade) {
      setSelectionMade(true);
    }

    let encodedIds = [];
    let newVehicleSelection = {};
    let pipFilter = {};

    optionTypes.forEach(({ id }) => {
      const key = id?.toUpperCase();
      newVehicleSelection[key] = selectedOption[key];
      if (selectedOption[key]?.id?.length > 0) {
        if (!isPlp) {
          pipFilter[selectedOption[key]?.option] = selectedOption[key]?.id;
        } else {
          encodedIds.push(selectedOption[key]?.id);
        }
      } else {
        // Need to update local storage vehicle to "I don't know" default values if no current selection
        newVehicleSelection[key] = { id: '', displayValue: I_DONT_KNOW, option: id };
      }
    });

    savePersistedState(newVehicleSelection);
    onCarSelectionChange({ pipFitmentRequest, encodedIds, pipFilter });
    carPickerAnalyticsEvent('select-vehicle-click');

    if ((!initialCallbackOnValidation.current && !isPlp) || isPlp) {
      // Need to avoid bad setStates that occur on PIP page due to fitmentItems call on initial render
      dispatch({ action: 'SET_SELECTED_OPTIONS', value: { ...newVehicleSelection } });
    }
  };

  let buttonClasses = classes('car-picker-button', {
    'car-picker-button--browse-and-search': isPlp && !isMobile
  });

  // TODO: Not thrilled about this solution but hey we need to go live!
  if (!remainingOptions.length && triggerFitmentItemsCallback) {
    if (initialCallbackOnValidation.current && !isPlp) {
      // Call fitmentItems on initial PIP page render to display appropriate banner
      handleSelectionUpdate();
      initialCallbackOnValidation.current = false;
    }
  }

  return (
    <div className={buttonClasses}>
      <Button
        outline
        disabled={!!remainingOptions?.length}
        onClick={() => handleSelectionUpdate()}
        className={buttonClasses}
      >
        {selectionMade ? 'Edit Your Selection' : 'Confirm Your Selection'}
      </Button>
    </div>
  );
};

CarPickerButtons.propTypes = {};

CarPickerButtons.defaultProps = {};

CarPickerButtons.displayName = 'CarPickerButtons';
